{
  "goal": "Meta",
  "subAccount": "Subcuenta",
  "any": "Cualquiera",
  "table": {
    "client": "Cliente",
    "type": "Tipo de carteras modelo",
    "goal": "Meta",
    "accounts": "Cuenta(s)",
    "portfolioValue": "Valor de la cartera",
    "driftRebalanceRequired": "Activador de desviación",
    "internalDriftTrigger": "Activador de desviación interna",
    "liquidateRebalanceRequired": "Activador de liquidación",
    "cashTrigger": "Activador de efectivo",
    "tradeRequests": "Transacciones solicitadas",
    "updatedAt": "Última actualización",
    "organization": "Organización",
    "cashAvailableForTrade": "Efectivo disponible para operaciones",
    "expectedCash": "Efectivo previsto",
    "pendingCash": "Efectivo pendiente",
    "difference": "Diferencia requerida",
    "cashPercentage": "Porcentaje de efectivo",
    "portfolio": "Cartera modelo",
    "totalMarketValue": "Valor total de mercado",
    "tradeVerificationRequired": "Se requiere verificación comercial",
    "bulkTradeRequired": "Se requiere comercio al por mayor"
  },
  "tooltips": {
    "cashAvailableForTrade": "Estas son sus transacciones sin efectivo en proceso",
    "pendingCash": "Este es su efectivo pendiente",
    "UNPAIRED": "Transacciones solicitadas",
    "ILLIQUID": "Producto sin liquidez",
    "UNBLOCKED_BUYS": "Compras sin restricciones",
    "PAIRED": "Agrupado"
  },
  "types": {
    "GOAL": "Meta",
    "SUB_ACCOUNT": "Subcuenta",
    "HOUSEHOLD": "Unidad familiar"
  },
  "goalType": {
    "CAR": "Coche",
    "BUILD_WEALTH": "Generar riqueza",
    "RETIREMENT": "Jubilación",
    "MAJOR_PURCHASE": "Compra importante",
    "HOUSE": "Casa",
    "EDUCATION": "Educación",
    "VACATION": "Vacaciones",
    "START_A_BUSINESS": "Iniciar un negocio",
    "WEDDING": "Boda",
    "PARENTAL_LEAVE": "Licencia parental",
    "SAFETY_NET": "Red de seguridad",
    "OTHER": "Otros",
    "CASH_RESERVE": "Reserva de efectivo",
    "LEGACY": "Herencia",
    "GROUP": "Grupo",
    "RETIREMENT_INCOME": "Ingresos para la jubilación"
  },
  "filters": {
    "selectOrganization": "Seleccione una organización",
    "modalportfolioType": "Tipo de carteras modelo",
    "selectPortfolio": "Seleccionar cartera modelo",
    "selectAccountType": "Seleccionar tipo de cuenta",
    "selectAccount": "Seleccionar cuenta",
    "triggerType": "Tipo de activador",
    "driftRebalance": "Desviación",
    "internalDrift": "Desviación interna",
    "cash": "Efectivo",
    "liquidateRebalance": "Solo reequilibrio de liquidación",
    "anyRebalanceRequired": "Se requiere reequilibrio",
    "tradeRequests": "Transacciones solicitadas",
    "yes": "Sí",
    "no": "No",
    "bulkTradeRequiredReason": "Se requiere motivo de comercio al por mayor",
    "status": "Estado",
    "active": "Activo",
    "inactive": "Inactivo",
    "value": "Valor",
    "zero": "0$",
    "greaterThanZero": "Mayor que 0$",
    "tradeVerificationStatus": "Estado de verificación comercial",
    "verified": "Verificado",
    "unverified": "Sin verificar"
  },
  "household": "Unidad familiar"
}
